export default "__VITE_ASSET__DYLJYuIw__"